<template>
    <div class="flex space-x-1 items-center">
      <v-tooltip location="top">
        <template v-slot:activator="{ props }">
          <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
        </template>
        <div class="w-40 whitespace-normal text-center">
          {{tooltip}}
        </div>
      </v-tooltip>
      <span class="font-semibold text-sm 2xl:text-base">{{label}}</span>
    </div>
    <div class="mb-4">
      <TlTextField :placeholder="placeholder" v-model="search" />
    </div>
</template>

<script lang="ts">
import { Icon } from '@iconify/vue';
import TlTextField from '../../global/TlTextField.vue';

export default {
  name: 'ReferenceSearchInput',
  props: {
    tooltip: { type: String },
    label: { type: String },
    placeholder: { type: String },
    modelValue: String,
  },
  components: {
    Icon,
    TlTextField,
  },
  data() {
    return {
      search: this.modelValue,
    };
  },
  methods: {

  },
  watch: {
    search(newValue) {
      this.$emit('update:modelValue', newValue);
    },
  },
};
</script>
